import { contactInfo } from '@/mocks/homepage';

export default function Contact() {
  return (
    <section id="contact" className="w-full py-12 md:py-16 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="bg-gradient-to-r from-background-100 to-background-50 rounded-xl border border-background-200/60 p-8 md:p-10">
          <div className="flex flex-col lg:flex-row items-start gap-8">
            <div className="flex-1">
              <h2 className="text-xl md:text-2xl font-bold text-foreground-900 font-heading mb-3">
                联系我们
              </h2>
              <p className="text-sm text-foreground-500 leading-relaxed mb-6 max-w-md">
                {contactInfo.description}
              </p>
              <div className="flex flex-wrap gap-4 md:gap-6">
                <div className="flex items-center gap-3 bg-background-50 rounded-lg px-4 py-3 border border-background-200/50">
                  <div className="w-9 h-9 rounded-lg bg-primary-100 flex items-center justify-center">
                    <i className="ri-mail-line text-primary-600"></i>
                  </div>
                  <div>
                    <span className="text-xs text-foreground-400">电子邮件</span>
                    <p className="text-sm font-medium text-foreground-900">{contactInfo.email}</p>
                  </div>
                </div>
                <div className="flex items-center gap-3 bg-background-50 rounded-lg px-4 py-3 border border-background-200/50">
                  <div className="w-9 h-9 rounded-lg bg-accent-100 flex items-center justify-center">
                    <i className="ri-wechat-line text-accent-700"></i>
                  </div>
                  <div>
                    <span className="text-xs text-foreground-400">微信公众号</span>
                    <p className="text-sm font-medium text-foreground-900">{contactInfo.wechat}</p>
                  </div>
                </div>
                <div className="flex items-center gap-3 bg-background-50 rounded-lg px-4 py-3 border border-background-200/50">
                  <div className="w-9 h-9 rounded-lg bg-secondary-100 flex items-center justify-center">
                    <i className="ri-customer-service-line text-secondary-700"></i>
                  </div>
                  <div>
                    <span className="text-xs text-foreground-400">客服QQ</span>
                    <p className="text-sm font-medium text-foreground-900">{contactInfo.qq}</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="hidden lg:block self-center">
              <div className="w-48 h-48 rounded-2xl bg-background-50 border border-background-200/50 flex items-center justify-center overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Clean%20modern%20QR%20code%20with%20minimalist%20design%20on%20warm%20cream%20background%2C%20dark%20geometric%20pattern%2C%20professional%20style%2C%20no%20text%2C%20simple%20composition&width=400&height=400&seq=contact-qr&orientation=squarish"
                  alt="91视频公众号"
                  className="w-full h-full object-cover"
                />
              </div>
              <p className="text-xs text-foreground-400 text-center mt-3">扫码关注公众号</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}